import Home from '../../pages/home/Index.jsx'
import NotFound from '../../pages/not-found/Index.jsx'

export const rutasProtegidas = [
  {
    path: '/',
    element: <Home />,
    meta: {
      title: 'Inicio',
      requiereAdmin: false,
      requiereIdCertificado: true,
    },
  },
]

export const rutasPublicas = [
  {
    path: '/login',
    element: <NotFound />,
    meta: {
      title: 'Login',
    },
  },
]
